<script setup lang="ts">
import type { AllResponse, ContentResponseWithAncestors } from '~/server/types';
import SiteWideMessagingRenderer from '~/components/Aggregates/SiteWideMessaging/SiteWideMessagingRenderer.vue';

const route = useRoute();
const { isAuthenticated } = useAuth();

const { data, error } = await useFetch<ContentResponseWithAncestors>(`/api/content`, {
  cache: 'force-cache',
  query: {
    path: route.path,
    includeAncestors: true,
    expand: 'properties[$all[properties[$all]]]',
    fields: 'properties[$all]'
  }
});

if (error.value) {
  console.error('Request failed with error: ' + error.value?.message);
  if (error.value.statusCode === 404) {
    // handled in error.vue
    throw createError({ statusCode: 404 });
  }
}

// get local "messaging" components.
const localMessagingComponents = data.value?.properties?.overrideSiteWideMessaging;
const disabledSiteWideMessaging = data.value?.properties?.disableOnThisPage;
const isProductPage = computed(() => {
  return data.value.componentName == 'productPage';
});
</script>

<template>
  <div>
    <div v-if="isAuthenticated">
    <SiteWideMessagingRenderer
      v-if="!isProductPage"
      :items="localMessagingComponents?.items"
      :disable="disabledSiteWideMessaging"
    />
    </div>   
    
    <component v-if="data" :is="data.componentName" v-bind="data" />
  </div>
</template>
